<template>
 <div id="personalDetails">
  <div class="panel" v-if="isSituation">
    <h1 v-if="customerType === 'resi'">{{ $t('Summary.personal-details.title') }}</h1>
    <h1 v-if="customerType === 'pro'">{{ $t('Summary.personal-details.titlePro') }}</h1>
    <div class="information">
      <ul>
        <li>
          <SvgIcon icon="customer-name" class="icon"></SvgIcon>
          <span class="tab">{{ tmpFirstName }} {{ tmpLastName }}</span>
        </li>
        <li v-if="tmpBirthDate">
          <SvgIcon icon="customer-calendar" class="icon"></SvgIcon>
          <span class="tab">{{ tmpBirthDate }}</span>
        </li>
        <li v-if="tmpPhone.number">
          <SvgIcon icon="customer-phone" class="icon"></SvgIcon>
          <span class="tab">{{ tmpPhone.prefix }} {{ tmpPhone.number }}</span>
        </li>
        <li v-if="!noEmail && tmpMail">
          <SvgIcon icon="customer-mail" class="icon"></SvgIcon>
          <span class="tab">{{ tmpMail }}</span>
        </li>
        <li v-if="!disablePersonalDetails"><button class="button main" @click="$emit('personalDetails')">{{ $t('Summary.edit') }}</button></li>
        <li v-if="address.locality">
          <SvgIcon icon="customer-town" class="icon"></SvgIcon>
          <span class="tab">{{ address.locality.zipCode }} - {{ address.locality.town }}</span>
        </li>
        <li v-if="tmpCoholderFirstName">
          <span class="tab"><span class="bold">{{ $t('Summary.personal-details.coholder.label') }}</span></span>
        </li>
        <li v-if="tmpCoholderFirstName">
          <SvgIcon icon="customer-name" class="icon"></SvgIcon>
          <span class="tab">{{ tmpCoholderFirstName }} {{ tmpCoholderLastName }}</span>
        </li>
        <li v-if="tmpCoholderLastName && !disableCoholder" class="inline h-item-margin left"><button class="button date main" @click="$emit('coholder')">{{ $t('Summary.edit') }}</button> <button class="button main" @click="deleteCoholder()">{{ $t('Summary.delete') }}</button></li>
        <li v-if="!disableCoholder && customerType !== 'pro' && !tmpCoholderFirstName"> <button class="button main" @click="$emit('coholder')">{{ $t('Summary.personal-details.coholder.button') }}</button></li>
      </ul>
    </div>
    <div class="inline" :class="[fromLead && showSponsor && !disableSponsor ? 'space-between': 'right']">
      <button v-if="showSponsor && !disableSponsor && fromLead" class="button main" @click="$emit('sponsor')">{{ $t('Summary.personal-details.sponsor') }}</button>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      isSituation: true,
      tmpFirstName: null,
      tmpLastName: null,
      tmpBirthDate: null,
      tmpMail: null,
      tmpPhone: null,
      tmpCoholderFirstName: null,
      tmpCoholderLastName: null,
    };
  },
  props: {
    disableSponsor: {
      type: Boolean,
      required: false,
      default: true
    },
    disableCoholder: {
      type: Boolean,
      required: false,
      default: true
    },
    disablePersonalDetails: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters("common", ["fromLead"]),
    ...mapGetters("subscription", ["noEmail"]),
    ...mapState("contract", ["address"]),
    ...mapState("subscription", [
      "customerType",
      "firstName",
      "lastName",
      "birthDate",
      "coholderCivility",
      "coholderFirstName",
      "coholderLastName",
      "phone",
      "mail",
      "showSponsor",
      "agentCustomId"
    ]),
  },
  methods: {
    deleteCoholder() {
      this.$store.commit("subscription/setCoholderFirstName", null);
      this.$store.commit("subscription/setCoholderLastName", null);
      this.tmpCoholderFirstName = null;
      this.tmpCoholderLastName = null;
    }
  },
  created() {
    this.tmpFirstName = Object.assign(this.firstName);
    this.tmpLastName = Object.assign(this.lastName);
    this.tmpBirthDate = this.birthDate ? Object.assign(this.birthDate) : null;
    this.tmpMail = this.mail ? Object.assign(this.mail) : null;
    this.tmpPhone = this.phone ? {...this.phone} : null;
    this.tmpCoholderFirstName = this.coholderFirstName ? Object.assign(this.coholderFirstName) : null;
    this.tmpCoholderLastName = this.coholderLastName ? Object.assign(this.coholderLastName): null;
  }
};
</script>


// WEBPACK FOOTER //
// src/views/components/Summary/PersonalDetails.vue